(function (window, document) {
    'use strict';

    var requestSequence = 0;
    var activeRequest = null;

    function musicLibrary() {
        return document.querySelector('[data-music-library-interaction]');
    }

    function isCurrentMusicLibrary() {
        return window.location.pathname === '/music' && Boolean(musicLibrary());
    }

    function canEnhance() {
        return typeof window.fetch === 'function'
            && typeof window.URL === 'function'
            && typeof window.URLSearchParams === 'function'
            && typeof window.FormData === 'function';
    }

    function isPrimaryActivation(event) {
        return !event.defaultPrevented
            && event.button === 0
            && !event.metaKey
            && !event.ctrlKey
            && !event.shiftKey
            && !event.altKey;
    }

    function createResultsUrl(destination) {
        var resultsUrl = new URL('/music/results', window.location.origin);

        resultsUrl.search = destination.search;

        return resultsUrl;
    }

    function createFormDestination(form, submitter) {
        var destination = new URL(form.action, window.location.href);
        var query = new URLSearchParams(new FormData(form));

        if (submitter && submitter.name) {
            query.set(submitter.name, submitter.value);
        }

        query.delete('page');
        destination.search = query.toString();
        destination.hash = 'mu-search';

        return destination;
    }

    function createDisplayDestination(link) {
        var destination = new URL(link.href, window.location.href);

        destination.searchParams.delete('page');
        destination.hash = 'mu-search';

        return destination;
    }

    function elementFromHtml(html, selector) {
        var holder = document.createElement('div');

        holder.innerHTML = html;

        return holder.querySelector(selector);
    }

    function activeControl() {
        var element = document.activeElement;

        if (!element || !musicLibrary() || !musicLibrary().contains(element)) {
            return null;
        }

        if (element.matches('[name="q"], [name="genre"], [name="sort"], .music-library-search-submit')) {
            return {
                type: 'filter',
                name: element.getAttribute('name'),
                value: element.getAttribute('value'),
                searchSubmit: element.classList.contains('music-library-search-submit')
            };
        }

        if (element.matches('[data-music-library-display-link]')) {
            return {
                type: 'display',
                display: element.getAttribute('data-music-library-display')
            };
        }

        return null;
    }

    function restoreControl(control) {
        var selector;
        var element;
        var disclosure;

        if (!control) {
            return;
        }

        if (control.type === 'filter') {
            selector = control.searchSubmit
                ? '.music-library-search-submit'
                : '[data-music-library-filter-form] [name="' + control.name + '"]';

            if (control.name === 'sort' && control.value) {
                selector += '[value="' + control.value + '"]';
            }
        } else if (control.type === 'display') {
            selector = '[data-music-library-display-link][data-music-library-display="' + control.display + '"]';
        }

        element = selector && document.querySelector(selector);

        if (element) {
            disclosure = element.closest('details');

            if (disclosure) {
                disclosure.open = true;
            }

            element.focus();
        }
    }

    function updateHistory(destination, method) {
        var existingState = history.state && typeof history.state === 'object' ? history.state : {};
        var nextState = Object.assign({}, existingState, {
            iksonMusicLibraryResults: true
        });
        var destinationPath = destination.pathname + destination.search + destination.hash;

        if (method === 'push' && destination.href !== window.location.href) {
            history.pushState(nextState, '', destinationPath);
        }
    }

    function announceResultCount(region, count) {
        var status = region.querySelector('[data-music-library-results-status]');

        if (!status) {
            return;
        }

        status.textContent = count === 0
            ? 'No tracks found.'
            : count + ' ' + (count === 1 ? 'track' : 'tracks') + ' shown.';
    }

    function fallback(destination) {
        window.location.assign(destination.href);
    }

    function requestResults(destination, historyMethod) {
        var library = musicLibrary();
        var grid = document.querySelector('[data-music-library-grid-options]');
        var resultsRegion = document.querySelector('[data-music-library-results-region]');
        var control = activeControl();
        var sequence;
        var requestOptions;

        if (!library || !grid || !resultsRegion || !canEnhance()) {
            fallback(destination);
            return;
        }

        if (activeRequest && typeof activeRequest.abort === 'function') {
            activeRequest.abort();
        }

        requestSequence += 1;
        sequence = requestSequence;
        requestOptions = {
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };

        if (typeof window.AbortController === 'function') {
            activeRequest = new window.AbortController();
            requestOptions.signal = activeRequest.signal;
        } else {
            activeRequest = null;
        }

        resultsRegion.setAttribute('aria-busy', 'true');

        window.fetch(createResultsUrl(destination).href, requestOptions).then(function (response) {
            if (!response.ok) {
                throw new Error('The Music Library results could not be loaded.');
            }

            return response.json();
        }).then(function (payload) {
            var nextGrid;
            var nextResults;

            if (sequence !== requestSequence) {
                return;
            }

            if (!payload
                || typeof payload.grid_html !== 'string'
                || typeof payload.results_html !== 'string'
                || typeof payload.count !== 'number') {
                throw new Error('The Music Library results response was invalid.');
            }

            nextGrid = elementFromHtml(payload.grid_html, '[data-music-library-grid-options]');
            nextResults = elementFromHtml(payload.results_html, '[data-music-library-results-region]');

            if (!nextGrid || !nextResults) {
                throw new Error('The Music Library results response was incomplete.');
            }

            grid.replaceWith(nextGrid);
            resultsRegion.replaceWith(nextResults);
            document.dispatchEvent(new Event('ikson:music-library-tracks-updated'));
            announceResultCount(nextResults, payload.count);
            updateHistory(destination, historyMethod);
            restoreControl(control);
        }).catch(function (error) {
            if (sequence !== requestSequence || (error && error.name === 'AbortError')) {
                return;
            }

            fallback(destination);
        }).finally(function () {
            if (sequence === requestSequence) {
                activeRequest = null;
                var currentResultsRegion = document.querySelector('[data-music-library-results-region]');

                if (currentResultsRegion) {
                    currentResultsRegion.removeAttribute('aria-busy');
                }
            }
        });
    }

    document.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-music-library-filter-form]');

        if (!form || !isCurrentMusicLibrary() || !canEnhance()) {
            return;
        }

        event.preventDefault();
        requestResults(createFormDestination(form, event.submitter), 'push');
    });

    document.addEventListener('change', function (event) {
        var select = event.target.closest('[data-music-library-filter-select]');
        var form;

        if (!select || !isCurrentMusicLibrary()) {
            return;
        }

        form = select.closest('[data-music-library-filter-form]');

        if (form) {
            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
                return;
            }

            form.dispatchEvent(new Event('submit', {
                bubbles: true,
                cancelable: true
            }));
        }
    });

    document.addEventListener('click', function (event) {
        var link = event.target.closest('[data-music-library-display-link]');

        if (!link || !isPrimaryActivation(event) || !isCurrentMusicLibrary() || !canEnhance()) {
            return;
        }

        event.preventDefault();
        requestResults(createDisplayDestination(link), 'push');
    });

    window.addEventListener('popstate', function () {
        if (!isCurrentMusicLibrary()) {
            return;
        }

        requestResults(new URL(window.location.href), 'none');
    });
})(window, document);
